import WpApi from "../modules/wp-api";
import AutoComplete from "../modules/autocomplete";

export default class Search {
  constructor() {
    this.api = new WpApi();

    this.init();
  }

  init() {
    document.querySelector(".search-form").classList.add("is-loading");
    this.initAutoCompleteFields().then(() => {
      document.querySelector(".search-form").classList.remove("is-loading");
    });
  }

  async initAutoCompleteFields() {
    if (!document.querySelector(".search-form")) return;

    try {
      if (document.querySelector(".products-category")) {
        await this.api.fetchPosts("products-category").then((result) => {
          new AutoComplete(result, {
            selector: ".products-category",
          });
        });
      }

      await this.api.fetchPosts("products-producer").then((result) => {
        new AutoComplete(result, {
          selector: ".products-producer",
        });
      });

      await this.api.fetchPosts("cars").then((result) => {
        new AutoComplete(result, {
          selector: ".car-brands",
        });
      });

      await this.api.fetchPosts("car-model").then((result) => {
        new AutoComplete(result, {
          selector: ".car-models",
        });
      });
    } catch {
      throw new Error("Autocomplete fields can't be loaded!");
    }
  }
}
